/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Knihovna utilit pro práci s čísly.
 */
class Numeric {
  /**
   * Určí, jestli je předaná hodnota platným indexem pole.
   * Index je celé číslo v intervalu `<0, Infinity)`.
   * @param {number} value Hodnota k ověření.
   * @returns {boolean} Příznak, jestli jsou požadavky splněny.
   */
  static isIndex(value) {
    return Number.isInteger(value) && value > -1;
  }
}

export default Numeric;
